export default __webpack_public_path__ + "static/media/13d.1ba06d44.png";